import { useTranslation } from "react-i18next";
import { FlaskConicalIcon } from "lucide-react";

/**
 * True when this bundle was built for the staging environment. The deploy
 * script bakes VITE_DEPLOY_ENV (scripts/deployment/deploy-frontend.ts); every
 * other build leaves it unset.
 */
export function isStagingDeploy(): boolean {
  return import.meta.env.VITE_DEPLOY_ENV === "staging";
}

/**
 * Staging marker. Staging runs the same UI as the live app against
 * dev-api.vardic.eu and a separate database, so the two are easy to confuse in
 * a browser tab. This bar is always visible on staging and never renders on the
 * live host.
 */
export function StagingBanner() {
  const { t } = useTranslation("common");
  if (!isStagingDeploy()) return null;

  return (
    <div
      className="flex shrink-0 items-center gap-2 border-b border-warning/32 bg-warning/8 px-4 py-2 text-sm text-warning-foreground md:px-6"
      data-test="staging-banner"
      role="status"
    >
      <FlaskConicalIcon aria-hidden="true" className="size-4 shrink-0" />
      <p className="min-w-0 flex-1">
        <span className="font-semibold">{t("stagingBanner.title")}</span>{" "}
        {t("stagingBanner.body")}
      </p>
    </div>
  );
}
